export default __webpack_public_path__ + "static/media/registerbg.bdb7b1db.jpg";